/**
 * Is the applet currently in a state where we should enable the submit button?
 */
export default function isAppletComplete(applet) {
  if (applet.isLoading) return false
  if (!applet.applet_trigger.channel_module_name) return false
  if (!applet.applet_trigger.module_name) return false
  if (!applet.applet_actions.length) return false
  if (applet.applet_queries.length) {
    if (applet.applet_queries.some(aq => !aq.channel_module_name)) return false
    if (applet.applet_queries.some(aq => !aq.module_name)) return false
  }
  if (applet.applet_actions.some(aa => !aa.channel_module_name)) return false
  if (applet.applet_actions.some(aa => !aa.module_name)) return false
  return true
}
